import React from 'react';
import Checkbox from 'components/atoms/checkbox';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ManagementState } from 'store/modules/management_store/types';

interface FinishedFilterProps {
  filterWinner: boolean;
  setFilterWinner: React.Dispatch<React.SetStateAction<boolean>>;
  filterPartialWinner: boolean;
  setFilterPartialWinner: React.Dispatch<React.SetStateAction<boolean>>;
  filterLost: boolean;
  setFilterLost: React.Dispatch<React.SetStateAction<boolean>>;
  filterCancelled: boolean;
  setFilterCancelled: React.Dispatch<React.SetStateAction<boolean>>;
  filterFailed: boolean;
  setFilterFailed: React.Dispatch<React.SetStateAction<boolean>>;
  filterDeclined: boolean;
  setFilterDeclined: React.Dispatch<React.SetStateAction<boolean>>;
  filterRevoked: boolean;
  setFilterRevoked: React.Dispatch<React.SetStateAction<boolean>>;
}

const FinishedFilter = (props: FinishedFilterProps) => {
  const {
    filterWinner,
    setFilterWinner,
    filterPartialWinner,
    setFilterPartialWinner,
    filterLost,
    setFilterLost,
    filterCancelled,
    setFilterCancelled,
    filterFailed,
    setFilterFailed,
    filterDeclined,
    setFilterDeclined,
    filterRevoked,
    setFilterRevoked,
  } = props;

  const { management } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  return (
    <div className="d-md-flex d-block align-items-center">
      <Checkbox
        customClass="checkbox-success mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterWinner(!filterWinner)}
        label={`Vitórias(${management.management_summary.total_finished.winner})`}
        checked={filterWinner}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-info mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterPartialWinner(!filterPartialWinner)}
        label={`Vitórias Parciais(${management.management_summary.total_finished.partial_winner})`}
        checked={filterPartialWinner}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-danger mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterLost(!filterLost)}
        label={`Perdidas(${management.management_summary.total_finished.lost})`}
        checked={filterLost}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-purple mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterCancelled(!filterCancelled)}
        label={`Anuladas(${management.management_summary.total_finished.cancelled})`}
        checked={filterCancelled}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-orange mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterFailed(!filterFailed)}
        label={`Fracassadas(${management.management_summary.total_finished.failed})`}
        checked={filterFailed}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-warning mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterDeclined(!filterDeclined)}
        label={`Declinadas(${management.management_summary.total_finished.declined})`}
        checked={filterDeclined}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-brown mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterRevoked(!filterRevoked)}
        label={`Revogadas(${management.management_summary.total_finished.revoked})`}
        checked={filterRevoked}
        disabled={false}
      />
    </div>
  );
};

export default FinishedFilter;
